module.exports = __webpack_public_path__ + "static/img/1_01.ad5d6e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250618/1_01.jpg
// module id = tg+N
// module chunks = 0